import { Users, Clock, SlidersHorizontal, Rocket } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const BENEFITS = [
  { icon: Users, title: "Yeni Müşterilere Ulaş", desc: "Bulunduğun bölgede araç yıkama ve detailing hizmeti arayan yeni müşterilere ulaş." },
  { icon: Clock, title: "Boş Zamanlarını Değerlendir", desc: "Çalışma programına uygun talepleri seç ve kapasiteni daha verimli kullan." },
  { icon: SlidersHorizontal, title: "Teklifini Kendin Belirle", desc: "Hangi işe teklif vereceğine ve hizmet fiyatına sen karar ver." },
  { icon: Rocket, title: "İşini Büyüt", desc: "Dijital kanallardan yeni müşteri kazanarak işletmeni veya bireysel hizmetini büyüt." },
];

export const Benefits = () => {
  return (
    <section id="avantajlar" className="relative py-24 sm:py-32 bg-[#F7FAFC]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <SectionLabel>Avantajlar</SectionLabel>
          <h2 className="mt-5 max-w-3xl font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[#172033]">
            Neden YıkaGel Partneri Olmalısın?
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-12">
          {/* Feature image card */}
          <Reveal className="md:col-span-5" delay={0.05}>
            <div className="relative h-full min-h-[320px] overflow-hidden rounded-3xl">
              <img
                src="https://images.unsplash.com/photo-1783323260497-0e779e3d517d?auto=format&fit=crop&w=800&q=80"
                alt="Güler yüzlü YıkaGel partneri"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B3B75]/85 via-[#0B3B75]/25 to-transparent" />
              <div className="absolute bottom-0 p-8">
                <p className="font-heading text-2xl font-bold text-white leading-tight">
                  Kendi işinin patronu ol, müşterilerini YıkaGel getirsin.
                </p>
              </div>
            </div>
          </Reveal>

          {/* Benefit cards */}
          <div className="md:col-span-7 grid gap-6 sm:grid-cols-2">
            {BENEFITS.map((b, i) => {
              const Icon = b.icon;
              return (
                <Reveal key={i} delay={i * 0.07}>
                  <div
                    data-testid={`benefit-card-${i + 1}`}
                    className="group h-full rounded-3xl border border-gray-100 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#1677FF]/30 hover:shadow-[0_24px_50px_-28px_rgba(11,59,117,0.4)]"
                  >
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#1677FF]/8 text-[#1677FF] transition-colors group-hover:bg-[#1677FF] group-hover:text-white">
                      <Icon size={22} />
                    </span>
                    <h3 className="mt-5 font-heading text-lg font-bold text-[#172033]">{b.title}</h3>
                    <p className="mt-2.5 text-[15px] leading-relaxed text-[#667085]">{b.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
